import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '✅',
    title: 'Diccionario Esencial',
    desc: 'Las 2.000 palabras más usadas del portugués brasileño, clasificadas en 30 categorías temáticas con el sistema ✅⚠️🆕 para saber en segundos si la palabra es igual, similar o nueva.',
    value: '$15.000'
  }, {
    id: '02',
    emoji: '🗣️',
    title: '1.000 Frases Listas para Usar',
    desc: 'Desde saludos hasta negociaciones. Organizadas por situación y nivel. Ninguna es de relleno — todas son de uso real y cotidiano en Brasil.',
    value: '$12.000'
  }, {
    id: '03',
    emoji: '🚫',
    title: 'Guía de Falsos Amigos',
    desc: 'Los 300+ errores que parecen español pero significan algo completamente diferente en portugués. Porque "embaraçada" no es embarazada, "propina" no es propina y "polvo" no es polvo.',
    value: '$10.000'
  }, {
    id: '04',
    emoji: '📅',
    title: 'Plan de Estudio 90 Días',
    desc: 'Calendario día por día con 20-30 minutos diarios para ir del nivel básico al intermedio real. Con mini-tests semanales y checklist de logros por etapa.',
    value: '$8.000'
  }];
  return <section className="py-20 bg-black text-white relative overflow-hidden" data-id="element-20">
      <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-900/20 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-400/20 text-emerald-400 mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="md:text-4xl font-extrabold mb-4 text-[24px]" data-id="element-27">
            🎁 4 BONUS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-28">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-zinc-900/80 border border-emerald-900/40 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-emerald-500/60 transition-colors" data-id="element-29">
              <div className="absolute top-0 right-0 bg-emerald-900/60 text-emerald-200 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-30">
                Bonus {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-31">
                <div className="text-4xl" data-id="element-32">{bono.emoji}</div>
                <div data-id="element-33">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-34">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-300 text-sm leading-relaxed" data-id="element-35">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-emerald-900/30 flex items-center justify-between" data-id="element-36">
                <span className="text-zinc-500 line-through text-sm" data-id="element-37">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-black tracking-wide" data-id="element-38">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-39">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-emerald-400/30 rounded-xl px-8 py-4" data-id="element-40">
            <p className="text-lg" data-id="element-41">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-42">$45.000</span>{' '}
              <span className="text-emerald-400 font-bold mx-2" data-id="element-43">→</span>{' '}
              <span className="font-black text-xl" data-id="element-44">GRATIS con tu Megapack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}